"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _heroBrand = _interopRequireDefault(require("../styles/hero-brand.css"));
var _heroBrand2 = _interopRequireDefault(require("./hero-brand.props/hero-brand.defaultProps"));
var _heroBrand3 = _interopRequireDefault(require("./hero-brand.props/hero-brand.propTypes"));
var _heroTextBlock = _interopRequireDefault(require("./hero-text-block"));
var _heroBackgroundVideoButton = _interopRequireDefault(require("./hero-background-video-button"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp,
  appendImageOptimization = dataUtils.appendImageOptimization;
var applyDarkTheme = function applyDarkTheme(data, theme) {
  return data.theme === 'dark' ? theme[data.theme] : '';
};
var mobileWidthThreshold = 480;
var HeroBackground = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(HeroBackground, _React$Component);
  function HeroBackground(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.heroVideo = /*#__PURE__*/_react["default"].createRef();
    _this.state = {
      videoIsPlaying: false,
      readyState: 0,
      isDesktop: typeof window !== 'undefined' && (window.innerWidth === undefined || window.innerWidth > mobileWidthThreshold),
      shouldPreload: false,
      orientationChangePending: true,
      hideVideoOnMobile: false
    };
    _this.mql = null;
    _this.toggleVideoPlay = _this.toggleVideoPlay.bind((0, _assertThisInitialized2["default"])(_this));
    _this.videoPlay = _this.videoPlay.bind((0, _assertThisInitialized2["default"])(_this));
    _this.videoPause = _this.videoPause.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleVideoReady = _this.handleVideoReady.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onOrientationChange = _this.onOrientationChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setDesktopMode = _this.setDesktopMode.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = HeroBackground.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var screenWidth = typeof window !== 'undefined' && window.innerWidth;
    var isDesktop = screenWidth > mobileWidthThreshold;
    var _this$props$data = this.props.data,
      hideVideoOnMobile = _this$props$data.hideVideoOnMobile,
      autoPlayVideoOnMobile = _this$props$data.autoPlayVideoOnMobile;
    var readyState = this.state.readyState;
    if (this.heroVideo.current !== null && readyState === 0) {
      this.heroVideo.current.addEventListener('pause', this.videoPause);
      if (isDesktop || autoPlayVideoOnMobile) this.handleVideoReady();
      if (typeof window !== 'undefined' && (isDesktop || autoPlayVideoOnMobile)) {
        this.heroVideo.current.addEventListener('canplay', this.videoPlay);
      }
      this.setState(function (prevState) {
        return {
          readyState: prevState.readyState++,
          orientationChangePending: false
        };
      });
    }
    if (typeof window !== 'undefined') {
      if ('onorientationchange' in window) {
        window.addEventListener('orientationchange', this.onOrientationChange, false);
      }
    }
    this.setState({
      // eslint-disable-line
      isDesktop: isDesktop,
      shouldPreload: screenWidth > 0 && (isDesktop || autoPlayVideoOnMobile),
      orientationChangePending: false
    });
    if (hideVideoOnMobile && typeof window !== 'undefined') {
      this.setupMediaQuery();
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.heroVideo.current !== null) {
      this.heroVideo.current.removeEventListener('canplay', this.videoPlay);
      this.heroVideo.current.removeEventListener('pause', this.videoPause);
    }
    if (typeof window !== 'undefined') {
      if ('onorientationchange' in window) {
        window.removeEventListener('orientationchange', this.onOrientationChange, false);
      }
    }
    if (this.mql !== null) {
      this.mql.removeListener(this.handleVideoMobileShow);
    }
  };
  _proto.handleVideoMobileShow = function handleVideoMobileShow(mql) {
    this.setState({
      hideVideoOnMobile: mql.matches
    });
  };
  _proto.handleVideoReady = function handleVideoReady() {
    if (this.heroVideo.current.getAttribute('src') !== '') {
      this.videoPlay();
    }
  };
  _proto.onOrientationChange = function onOrientationChange() {
    var time = 300;
    this.toggleVideoPlay(true);
    this.setState({
      orientationChangePending: true
    });
    if (typeof window !== 'undefined') {
      window.setTimeout(this.setDesktopMode, time);
    }
  };
  _proto.setupMediaQuery = function setupMediaQuery() {
    this.mql = window.matchMedia('(max-width: 768px)');
    this.mql.addListener(this.handleVideoMobileShow.bind(this));
    this.handleVideoMobileShow(this.mql);
  };
  _proto.setDesktopMode = function setDesktopMode() {
    var autoPlayVideoOnMobile = this.props.data.autoPlayVideoOnMobile;
    var screenWidth = typeof window !== 'undefined' && window.innerWidth;
    var isDesktop = screenWidth > mobileWidthThreshold;
    this.setState({
      isDesktop: isDesktop,
      shouldPreload: screenWidth > 0 && (isDesktop || autoPlayVideoOnMobile),
      orientationChangePending: false
    });
  };
  _proto.getVideoSrc = function getVideoSrc(data, isDesktop, orientationChangePending) {
    var mobileVideo = handleNestedProp(data, 'data.mobileVideo.source');
    var desktopVideo = handleNestedProp(data, 'data.video.source');
    var hasMobileVideo = this.hasSrc(mobileVideo);
    var hasDesktopVideo = this.hasSrc(desktopVideo);
    if (!isDesktop && hasMobileVideo && !orientationChangePending) {
      return mobileVideo;
    }
    if (hasDesktopVideo && !orientationChangePending) {
      return desktopVideo;
    }
    return '';
  };
  _proto.getImageSrc = function getImageSrc(data, isDesktop, orientationChangePending) {
    var mobileImageWidth = 960;
    var desktopImageWidth = 1440;

    // Detect screen size
    var mobileImage = handleNestedProp(data, 'data.mobileImage.image');
    var desktopImage = handleNestedProp(data, 'data.backgroundImage.image');
    var hasMobileImage = this.hasSrc(mobileImage);
    var hasDesktopImage = this.hasSrc(desktopImage);
    var isBackground = false;
    var isWebp = true;
    var imageQuality = 70;
    if (!isDesktop && hasMobileImage && !orientationChangePending) {
      return appendImageOptimization(mobileImage, mobileImageWidth, isBackground, isWebp, imageQuality);
    }
    if (hasDesktopImage && !orientationChangePending) {
      return appendImageOptimization(desktopImage, desktopImageWidth, isBackground, isWebp, imageQuality);
    }
    return '';
  };
  _proto.getImageSrcSet = function getImageSrcSet(data, isDesktop, orientationChangePending) {
    // Detect screen size
    var mobileImage = handleNestedProp(data, 'data.mobileImage.image');
    var desktopImage = handleNestedProp(data, 'data.backgroundImage.image');
    var hasMobileImage = this.hasSrc(mobileImage);
    var hasDesktopImage = this.hasSrc(desktopImage);
    var isBackground = false;
    var isWebp = true;
    var imageQuality = 70;
    if (!isDesktop && hasMobileImage && !orientationChangePending) {
      return [appendImageOptimization(mobileImage, 320, isBackground, isWebp, imageQuality) + " 320w", appendImageOptimization(mobileImage, 480, isBackground, isWebp, imageQuality) + " 480w", appendImageOptimization(mobileImage, 720, isBackground, isWebp, imageQuality) + " 720w", appendImageOptimization(mobileImage, 960, isBackground, isWebp, imageQuality) + " 960w", appendImageOptimization(mobileImage, 1080, isBackground, isWebp, imageQuality) + " 1080w", appendImageOptimization(mobileImage, 1440, isBackground, isWebp, imageQuality) + " 1440w", appendImageOptimization(mobileImage, 2160, isBackground, isWebp, imageQuality) + " 2160w"].join(',');
    }
    if (hasDesktopImage && !orientationChangePending) {
      return [appendImageOptimization(desktopImage, 320, isBackground, isWebp, imageQuality) + " 320w", appendImageOptimization(desktopImage, 480, isBackground, isWebp, imageQuality) + " 480w", appendImageOptimization(desktopImage, 720, isBackground, isWebp, imageQuality) + " 720w", appendImageOptimization(desktopImage, 960, isBackground, isWebp, imageQuality) + " 960w", appendImageOptimization(desktopImage, 1080, isBackground, isWebp, imageQuality) + " 1080w", appendImageOptimization(desktopImage, 1440, isBackground, isWebp, imageQuality) + " 1440w", appendImageOptimization(desktopImage, 2160, isBackground, isWebp, imageQuality) + " 2160w"].join(',');
    }
    return '';
  };
  _proto.getMediaSources = function getMediaSources(data, isDesktop, orientationChangePending) {
    var mobileAltText = handleNestedProp(data, 'data.mobileImage.altText');
    var mediaSources = {
      video: this.getVideoSrc(data, isDesktop, orientationChangePending),
      image: this.getImageSrc(data, isDesktop, orientationChangePending),
      imageSrcSet: this.getImageSrcSet(data, isDesktop, orientationChangePending),
      altText: !isDesktop && !orientationChangePending && mobileAltText && mobileAltText !== ' ' ? mobileAltText : handleNestedProp(data, 'data.backgroundImage.altText')
    };
    return mediaSources;
  };
  _proto.videoPause = function videoPause() {
    var _this2 = this;
    if (!this.heroVideo) return;
    var videoWillPause = this.heroVideo.current.pause();
    if (videoWillPause !== undefined) {
      videoWillPause.then(function () {
        _this2.setState({
          videoIsPlaying: false
        });
      });
    } else {
      this.setState({
        videoIsPlaying: false
      });
    }
  };
  _proto.videoPlay = function videoPlay() {
    var _this3 = this;
    var videoWillPlay = this.heroVideo.current.play();
    if (videoWillPlay !== undefined) {
      videoWillPlay.then(function () {
        _this3.setState({
          videoIsPlaying: true
        });
      });
    } else {
      this.setState({
        videoIsPlaying: true
      });
    }
  };
  _proto.toggleVideoPlay = function toggleVideoPlay(videoIsPlaying) {
    if (videoIsPlaying) {
      this.videoPause();
    } else {
      this.videoPlay();
    }
  };
  _proto.hasSrc = function hasSrc(src) {
    return src && src !== ' ' && src !== '';
  };
  _proto.renderVideo = function renderVideo(data, theme, config) {
    var _this$state = this.state,
      videoIsPlaying = _this$state.videoIsPlaying,
      isDesktop = _this$state.isDesktop,
      orientationChangePending = _this$state.orientationChangePending,
      shouldPreload = _this$state.shouldPreload;
    var mediaSources = this.getMediaSources(data, isDesktop, orientationChangePending);
    var videoShouldLoop = handleNestedProp(data, 'data.video.loop');
    var videoOverlayShowClass = videoIsPlaying ? 'hideVideoOverlay' : 'showVideoOverlay';
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _heroBrand["default"].videoOverlay + " " + _heroBrand["default"][videoOverlayShowClass]
    }), /*#__PURE__*/_react["default"].createElement("link", {
      rel: "preload",
      as: "image",
      href: mediaSources.image
    }), /*#__PURE__*/_react["default"].createElement("video", {
      ref: this.heroVideo,
      loop: isDesktop ? videoShouldLoop : 'false',
      muted: true,
      preload: shouldPreload ? 'auto' : 'none',
      playsInline: true,
      poster: mediaSources.image,
      className: "" + applyDarkTheme(data, theme),
      src: mediaSources.video
    }), /*#__PURE__*/_react["default"].createElement(_heroTextBlock["default"], {
      theme: theme,
      data: data,
      config: config
    }), /*#__PURE__*/_react["default"].createElement(_heroBackgroundVideoButton["default"], {
      data: data,
      videoIsPlaying: videoIsPlaying,
      theme: theme,
      toggleVideoPlay: this.toggleVideoPlay
    }));
  };
  _proto.renderBackground = function renderBackground(data, theme, config) {
    var _this$state2 = this.state,
      isDesktop = _this$state2.isDesktop,
      orientationChangePending = _this$state2.orientationChangePending,
      hideVideoOnMobile = _this$state2.hideVideoOnMobile;
    var mediaSources = this.getMediaSources(data, isDesktop, orientationChangePending);
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (!mediaSources.video || hideVideoOnMobile) && /*#__PURE__*/_react["default"].createElement("img", {
      fetchpriority: "high",
      className: _heroBrand["default"].imageBackground,
      src: mediaSources.image,
      srcSet: mediaSources.imageSrcSet,
      alt: mediaSources.altText
    }));
  };
  _proto.render = function render() {
    var _this$props = this.props,
      data = _this$props.data,
      theme = _this$props.theme,
      config = _this$props.config;
    var hideVideoOnMobile = this.state.hideVideoOnMobile;
    return data.video && data.video.source && !hideVideoOnMobile ? /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + applyDarkTheme(data, theme) + " " + _heroBrand["default"].backgroundWrapperVideo + " " + (data.theme === 'dark' ? _heroBrand["default"].dark : ' ')
    }, this.renderVideo(data, theme, config)) : /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + applyDarkTheme(data, theme) + " " + _heroBrand["default"].backgroundWrapper + " " + (data.theme === 'dark' ? _heroBrand["default"].dark : ' ')
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: applyDarkTheme(data, theme) + " " + _heroBrand["default"].background + " " + (data.textBlockPosition === 'center' ? 'center' : null)
    }, this.renderBackground(data, theme, config), /*#__PURE__*/_react["default"].createElement(_heroTextBlock["default"], {
      theme: theme,
      data: data,
      config: config
    })));
  };
  return HeroBackground;
}(_react["default"].Component);
HeroBackground.defaultProps = {
  data: _heroBrand2["default"],
  config: {}
};
var _default = HeroBackground;
exports["default"] = _default;